module.exports = __webpack_public_path__ + "static/media/bg-timeline-tablet.6ffc3b71.jpg";